import { render, staticRenderFns } from "./product_none.vue?vue&type=template&id=624a4f3e&scoped=true"
import script from "./product_none.vue?vue&type=script&lang=js"
export * from "./product_none.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "624a4f3e",
  null
  
)

export default component.exports